import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { NETLIFY_API_ROOT } from "../assets/url";

export const loadProducts = createAsyncThunk(
  "products/loadProducts",
  async () => {
    const data = await fetch(`${NETLIFY_API_ROOT}/api/products`);
    const json = await data.json();

    return json.data;
  }
);

export const productReducer = createSlice({
  name: "products",
  initialState: {
    allProducts: [],
    loading: "",
    error: "",
    category: "",
  },
  reducers: {
    updateCategory: (state, action) => {
      state.category = action.payload;
    },
  },
  extraReducers: {
    [loadProducts.pending]: (state, action) => {
      state.loading = "loading";
    },
    [loadProducts.fulfilled]: (state, action) => {
      state.loading = "success";
      state.allProducts = action.payload;
    },
    [loadProducts.rejected]: (state, action) => {
      state.loading = "failed";
      state.error = action.payload;
    },
  },
});

export const { updateCategory } = productReducer.actions;
export const selectProducts = state => state.products.allProducts;
export const selectCurrentProduct = state => state.products.current;
export const selectCategory = state => state.products.category;
export default productReducer.reducer;
